import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { OutOfServiceIcon } from 'assets/icons';
import { Container } from './styles';
import colors from 'constants/colors';

const ModalPartialAuthorizationAccepted = ({
  isOpen,
  setIsOpen,
  amount,
  balance,
  retryFunction,
}) => {

  const title = "Partial Authorization Accepted"
  const message = `The customer’s card approved but only for a total of $${amount.toFixed(2)}. The customer must present another credit card for the remaining balance of $${balance.toFixed(2)}.`

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }
          border-color: ${colors.yellow};   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <OutOfServiceIcon />
        {title && <div className="title">{title}</div>}
        <div className="text">{message}</div>
        <div className="buttonContainer">
          <Button
            success
            onClick={retryFunction}
            additionalstyle={`
              width: 116px;
            `}
          >
            Continue
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalPartialAuthorizationAccepted;
